/**
 * OperatorHydrated.contract.ts — OPERATOR IDENTITY™ Phase 3 (Build 2.08.0).
 * Published by the Hydration Orchestrator immediately after the operator
 * profile hydration step so downstream surfaces can personalise at once.
 */

import type { EventContract } from '../EventContractRegistry';

export const OperatorHydratedContract: EventContract = {
  name: 'OperatorHydrated',
  version: 1,
  description: 'Published after the operator profile hydration step of the cloud-restore pipeline.',
  publishers: ['hydration-orchestrator'],
  subscribers: [],
  fields: [
    { name: 'hasPersona', type: 'boolean', required: true, description: 'Whether an operator profile exists after hydration' },
    { name: 'onboardingCompleted', type: 'boolean', required: true, description: 'Whether the operator has completed onboarding' },
    { name: 'operatorName', type: 'string', required: false, description: 'Operator display name, when set' },
    { name: 'personaVersion', type: 'string', required: false, description: 'Persona schema version (1 or 2)' },
  ],
  allowExtraFields: false,
  timestampPolicy: 'Set to Date.now() at publish time.',
  stability: 'stable',
  deprecated: false,
  example: { hasPersona: true, onboardingCompleted: true, operatorName: 'Alex Roamer', personaVersion: '2' },
};
